import React from "react";
import ReactSelect from "react-select";
import { ErrorMessage } from "formik";

export default function CommonCategoryOption({
    formik,
    prop,
    options,
    selectCategory,
    setSelectCategory,
    setSelectSubcategory,
}) {

    const handleCategoryChange = (selectedOption, formik) => {
        setSelectCategory(selectedOption);
        formik.setFieldValue("category_id", selectedOption?.value || "");
        formik.setFieldValue("category_index", selectedOption || "");
        formik.setFieldValue("sub_category_id", "");
        formik.setFieldValue("subcategory_index", "");
        formik.setFieldValue("sub_category_title", "");
        if (setSelectSubcategory) {
            setSelectSubcategory(null);
        }
    };
    return (
        <div className="form-group">
            <label>{prop.title}</label>
            <ReactSelect
                options={
                    Array.isArray(options)
                        ? options.map((skill) => ({
                            value: skill.id,
                            label: skill.title,
                        }))
                        : []
                }
                placeholder={prop.placeholder}
                value={selectCategory}
                onChange={(option) => handleCategoryChange(option, formik)}
            />
            <ErrorMessage name={prop.name} component="div" className="error" />
        </div>
    );
}
